<template>
  <div class="dataList">
    <!-- 海关查询 -->
    <div class="rightTop" v-if="type=='customs'">
      <div class="title">
        <img src="@/assets/img/14.png" alt />
        <span>筛选条件</span>
      </div>
      <div class="con" style=" overflow: inherit;">
        <div class="conLeft1 conLeft1_1">
          <div class="selectBox">
            <span>选择时间</span>
            <el-select v-model="startYear" placeholder="请选择" @change="changeSelect" class="timer">
              <el-option v-for="item in timeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <p>-</p>
            <el-select v-model="endYear" placeholder="请选择" @change="changeSelect" class="timer">
              <el-option v-for="item in timeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="conLeft2">
          <div class="selectBox">
            <span>企业性质</span>
            <!-- <el-select
              v-model="hgcompanyType"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in companyTypeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="hgcompanyType"
              collapse-tags
              :show-all-levels="false"
              :options="companyTypeData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
          <div class="selectBox">
            <span>运输方式</span>
            <!-- <el-select
              v-model="hgtransport"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in transportData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="hgtransport"
              collapse-tags
              :show-all-levels="false"
              :options="transportData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
          <div class="selectBox">
            <span>贸易流向</span>
            <!-- <el-select
              v-model="hgtradeflow"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in tradeflowData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="hgtradeflow"
              collapse-tags
              :show-all-levels="false"
              :options="tradeflowData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
        </div>
        <div class="conLeft3">
          <div class="selectBox">
            <span>贸易方式</span>
            <!-- <el-select
              v-model="hgtrademode"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in trademodeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="hgtrademode"
              collapse-tags
              :show-all-levels="false"
              :options="trademodeData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>

          <div class="selectBox">
            <span>企业所在地</span>
            <!-- <el-select
              v-model="hgregion"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in regionData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="hgregion"
              collapse-tags
              :show-all-levels="false"
              :options="regionData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
        </div>
        <div class="conLeft4" style="position:relative">
          <div class="selectBox">
            <span>选择字段</span>
            <el-input v-model="hgselectedPara" readonly></el-input>
            <button style="margin-left:10px;border:0;" class="button" @click="chooseTextFn(3)">选择</button>
          </div>
          <div class="selectBox">
            <span>HS商品</span>
            <el-input v-model="hsname" readonly></el-input>
            <button style="margin-left:10px;border:0;" class="button" @click="hsNameFn(3)">选择</button>
          </div>
          <div class="selectBox">
            <div class="button" @click="changeSelect">查询</div>
          </div>
          <!-- hs商品弹出框 -->
          <el-card
            class="box-hsNameFn"
            style="position: absolute;top:62px;left:633px;height:430px;width:48%;z-index: 10000;display: none;"
          >
            <div
              class="ticket_alert_box"
              style="width:98%;height:350px;margin:0 auto;overflow:hidden;"
            >
              <div
                class="ticket_alert_l_two"
                style="width:47%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;"
              >
                <div style="overflow:hidden;">
                  <span style="font-weight:bold;">可选字段[{{hsnameData.ParamsNum}}]个</span>
                </div>
                <div
                  style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
                >
                  <el-tree
                    ref="tree"
                    :data="hsnameData.Params"
                    show-checkbox
                    node-key="typeId"
                    :props="hsNameText.defaultProps"
                    @check="checkHsName"
                    style="width:100%;height:100%;"
                  ></el-tree>
                </div>
              </div>
              <div
                class="ticket_alert_l_three"
                style="width:47%;height:100%;display: inline-block;overflow:hidden;float:left;"
              >
                <div style="overflow: hidden;">
                  <span style="font-weight:bold;">已选字段[{{hsNameText.checkedCities.length}}]个</span>
                  <span @click="hsRemoveFn" style="float: right;color:#ef3938;cursor: pointer;">全部删除</span>
                </div>
                <div
                  style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
                >
                  <ul style="padding:2px 10px;">
                    <li
                      v-for="(v,i) in hsNameText.checkedCities"
                      @click="hsRemoveFn2(v)"
                      style="width:100%;white-space: nowrap;cursor: pointer;"
                      :key="i"
                    >
                      <img
                        src="../assets/upmarket/remove.png"
                        alt
                        style="display: inline-block;height: 13px;margin-right: 4px;"
                      />
                      <span
                        style="font-size: 14px;display: inline-block;line-height: 1;width:90%;"
                      >{{v.typeName}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="search_upmarket_btn"
              @click="hsNameBtn"
              style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:12px;"
            >确定</div>
          </el-card>
          <!--选择字段弹出框 -->
          <el-card
            class="box-card_two"
            style="position: absolute;top:64px;height:430px;width:48%;z-index: 10000;display: none;"
          >
            <div
              class="ticket_alert_box"
              style="width:98%;height:350px;margin:0 auto;overflow:hidden;"
            >
              <div
                class="ticket_alert_l_two"
                style="width:47%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;"
              >
                <div style="overflow:hidden;">
                  <span style="font-weight:bold;">可选字段[{{selectedParametersData.length}}]个</span>
                  <el-checkbox
                    :indeterminate="searchText.isIndeterminate"
                    v-model="searchText.checkAll"
                    @change="hghandleCheckAllChange2"
                    style="float:right;"
                  >全选</el-checkbox>
                </div>

                <div
                  style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
                >
                  <el-checkbox-group
                    v-model="searchText.checkedCities"
                    @change="hghandleCheckedCitiesChange2"
                  >
                    <el-checkbox
                      v-for="item in selectedParametersData"
                      :label="item.name"
                      :key="item.value"
                      style="width:90%;margin:0 auto;display: block;white-space: nowrap;"
                    >{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <div
                class="ticket_alert_l_three"
                style="width:47%;height:100%;display: inline-block;overflow:hidden;float:left;"
              >
                <div style="overflow: hidden;">
                  <span style="font-weight:bold;">已选字段[{{searchText.checkedCities.length}}]个</span>
                  <span
                    @click="removeClickedUpMarketFn2"
                    style="float: right;color:#ef3938;cursor: pointer;"
                  >全部删除</span>
                </div>
                <div
                  style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
                >
                  <ul style="padding:2px 10px;">
                    <li
                      v-for="(v,i) in searchText.checkedCities"
                      @click="removeOneSelectedUpMarketFn2(v)"
                      style="width:100%;white-space: nowrap;cursor: pointer;"
                      :key="i"
                    >
                      <img
                        src="../assets/upmarket/remove.png"
                        alt
                        style="display: inline-block;height: 13px;margin-right: 4px;"
                      />
                      <span
                        style="font-size: 14px;display: inline-block;line-height: 1;width:90%;"
                      >{{v}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="search_upmarket_btn"
              @click="searchTextBtn"
              style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:12px;"
            >确定</div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 工业查询 -->
    <div class="rightTop" v-if="type=='industrial'">
      <div class="title">
        <img src="@/assets/img/14.png" alt />
        <span>筛选条件</span>
      </div>
      <div class="con" style=" overflow: inherit;">
        <div class="conLeft1 conLeft1_1">
          <div class="selectBox">
            <span class="w93">选择时间</span>
            <el-select v-model="startYear" placeholder="请选择" @change="changeSelect" class="timer">
              <el-option v-for="item in timeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <p>-</p>
            <el-select v-model="endYear" placeholder="请选择" @change="changeSelect" class="timer">
              <el-option v-for="item in timeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="conLeft2">
          <div class="selectBox">
            <span class="w93">企业所在地</span>
            <!-- <el-select
              v-model="gyregion"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option
                v-for="item in regionData"
                :key="item.id"
                :label="item.typeName"
                :value="item.typeName"
              ></el-option>
            </el-select>-->
            <el-cascader
              v-model="gyregion"
              collapse-tags
              :show-all-levels="false"
              :options="regionData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
          <div class="selectBox">
            <span class="w93">企业登记注册类型</span>
            <el-cascader
              v-model="gycompanyType"
              collapse-tags
              :show-all-levels="false"
              :options="companyTypeData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
          <div class="selectBox">
            <span class="w93">企业隶属关系</span>
            <!-- <el-select
              v-model="gyrelationType"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in relationData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="gyrelationType"
              collapse-tags
              :show-all-levels="false"
              :options="relationData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true,disabled:'valued'    }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
        </div>
        <div class="conLeft3" style="position:relative;">
          <div class="selectBox">
            <span class="w93">企业控股情况</span>
            <!-- <el-select
              v-model="gyholdingType"
              collapse-tags
              multiple
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option v-for="item in holdingTypeData" :key="item" :label="item" :value="item"></el-option>
            </el-select>-->
            <el-cascader
              v-model="gyholdingType"
              collapse-tags
              :show-all-levels="false"
              :options="holdingTypeData"
              :props="{ children: 'sonList',label:'typeName',value:'typeName',multiple: true,checkStrictly: true, disabled:'valued'   }"
              placeholder="请选择"
              @change="changeSelect"
            ></el-cascader>
          </div>
          <div class="selectBox">
            <span class="w93">选择字段</span>
            <el-input v-model="gyselectedPara" readonly></el-input>
            <button style="margin-left:10px;border:0;" class="button" @click="chooseTextFn(4)">选择</button>
          </div>
          <div class="selectBox">
            <div class="button" @click="changeSelect">查询</div>
          </div>
          <!-- 选择字段弹出框 -->
          <el-card
            class="box-card_two"
            style="position: absolute;top:62px;left:633px;height:430px;width:48%;z-index: 10000;display: none;"
          >
            <div
              class="ticket_alert_box"
              style="width:98%;height:350px;margin:0 auto;overflow:hidden;"
            >
              <div
                class="ticket_alert_l_two"
                style="width:47%;height:100%;margin-right:4%;display: inline-block;overflow:hidden;float:left;"
              >
                <div style="overflow:hidden;">
                  <span style="font-weight:bold;">可选字段[{{selectedParaData.ParamsNum}}]个</span>
                </div>
                <div
                  style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
                >
                  <el-tree
                    ref="trees"
                    :data="selectedParaData.Params"
                    show-checkbox
                    node-key="typeId"
                    :props="searchText.defaultProps"
                    @check="checkHgName"
                    style="width:100%;height:100%;"
                  ></el-tree>
                </div>
              </div>
              <div
                class="ticket_alert_l_three"
                style="width:47%;height:100%;display: inline-block;overflow:hidden;float:left;"
              >
                <div style="overflow: hidden;">
                  <span style="font-weight:bold;">已选字段[{{searchText.checkedCities.length}}]个</span>
                  <span @click="hgRemoveFn" style="float: right;color:#ef3938;cursor: pointer;">全部删除</span>
                </div>
                <div
                  style="margin-top: 6px;width:99%;height:296px;border:1px solid #dfdfdf;border-radius: 4px;overflow:scroll;"
                >
                  <ul style="padding:2px 10px;">
                    <li
                      v-for="(v,i) in searchText.checkedCities"
                      @click="hgRemoveFn2(v)"
                      style="width:100%;white-space: nowrap;cursor: pointer;"
                      :key="i"
                    >
                      <img
                        src="../assets/upmarket/remove.png"
                        alt
                        style="display: inline-block;height: 13px;margin-right: 4px;"
                      />
                      <span
                        style="font-size: 14px;display: inline-block;line-height: 1;width:90%;"
                      >{{v.typeName}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="search_upmarket_btn"
              @click="hgNameBtn"
              style="background:#3584ed;color:#fff;width:80px;height:30px;text-align: center;line-height: 30px;border-radius: 2px;float:right;margin-right: 2.2%;margin-top:12px;"
            >确定</div>
          </el-card>
        </div>
      </div>
    </div>
    <!--下载 -->
    <div class="rightCenter">
      <div class="centerTit">{{type=='customs'?'海关数据列表':type=='industrial'?'工业数据列表':''}}</div>
      <div class="centerCon">
        <div class="no">
          <span></span>
        </div>
        <div class="cueWords" v-show="hint">最多下载1000条</div>
        <div class="excel" @click="down()" @mouseenter="enter()" @mouseleave="leave()">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <!-- 海关表格 -->
    <div class="rightBottom" v-if="type=='customs'">
      <div class="tabulationBottom">
        <el-table
          :data="majorList"
          style="width: 100%"
          border
          size="mini"
          :fit="true"
          :cell-style="cellStyle1"
          @row-click="getDetails1"
        >
          <af-table-column type="index" label="序号" width="50" v-if="parameters"></af-table-column>
          <af-table-column :prop="i" :label="v" v-for="(v,i) in parameters" :key="i"></af-table-column>
        </el-table>
      </div>
    </div>
    <!-- 工业表格 -->
    <div class="rightBottom" v-if="type=='industrial'">
      <div class="tabulationBottom">
        <el-table
          :data="majorList"
          style="width: 100%"
          border
          size="mini"
          :fit="true"
          :cell-style="cellStyle1"
          @row-click="getDetails1"
        >
          <af-table-column type="index" label="序号" width="50" v-if="parameters"></af-table-column>
          <af-table-column :prop="i" :label="v" v-for="(v,i) in parameters" :key="i"></af-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="rightPaging" style="display:flex;align-item:center;">
      <div
        style="    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
      color: #BAC7D5;
      height:32px;
       line-height: 32px;"
      >共 {{total}} 条</div>
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        background
        @current-change="handleCurrentChange"
        :current-page="params.currPage"
        :page-size="params.pageSize"
        layout="prev, pager, next, jumper"
        :total="2000"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../../static/common/api/api.js";
window.api = api;
import magic from "../../static/common/magic.js";
import axios from "axios";
export default {
  props: ["type"],
  data() {
    return {
      params: {
        pageSize: 10, //每页多少条
        currPage: 1
      }, //筛选条件
      startYear: "", //开始时间
      endYear: "", //结束时间
      typeOnes: "",
      typeTwos: "",
      times: "",
      productNames: "",
      department: "",
      offset: 0, //从多少条开始
      limit: 10, //每页多少条
      // pageSize: 10, //每页多少条
      // currPage: 1,
      total: 0, //总条数
      //工业
      regionData: [], //企业所在地
      gyregion: "",
      companyTypeData: [], //企业登记注册类型
      gycompanyType: "",
      holdingTypeData: [], //企业控股情况
      gyholdingType: "",
      // entNameData: [], //企业名称
      relationData: [], //企业隶属关系
      gyrelationType: "",
      selectedParaData: [], //选择展示字段以英文，都好隔开的字符串
      gyselectedPara: "", //选择字段
      //海关
      trademodeData: [], //贸易方式
      hsname: "", // hs商品展示
      tradeflowData: [], //贸易流向
      hgtradeflow: "", //贸易流向
      hgtrademode: "", //贸易方式
      hgtransport: "", //运输方式
      hgcompanyType: "", //企业性质
      hgregion: "", //企业所在地
      transportData: [], //运输方式
      regionData: [], //企业所在地

      selectedParametersData: [], //选择展示字段以英文，都好隔开的字符串
      hsnameData: [], //hs商品
      hgselectedPara: "", //选择字段
      timeData: [], //时间数据
      majorList: [], // 表单数据
      parameters: [], // 表头数据
      input: "",
      searchText: {
        canSelect: [], //可选字段
        defaultProps: {
          children: "sonList",
          label: "typeName",
          disabled: "valued"
        },
        checkAll: false,
        checkedCities: [], //可选字段的默认选中
        isIndeterminate: false, //可选字段的默认选中
        choosedItems: "" //选中的字段
      },
      hsNameText: {
        canSelect: [], //可选字段
        defaultProps: {
          children: "sonList",
          label: "typeName",
          disabled: "valued"
        },
        checkAll: false,
        checkedCities: [], //可选字段的默认选中
        isIndeterminate: false, //可选字段的默认选中
        choosedItems: [] //选中的字段
      },
      // 下载提示
      hint: false
    };
  },
  methods: {
    //查询
    changeSelect(val) {
      var star = this.startYear.slice(0, this.startYear.length - 1)
        ? this.startYear.slice(0, this.startYear.length - 1)
        : null;
      var end = this.endYear.slice(0, this.endYear.length - 1)
        ? this.endYear.slice(0, this.endYear.length - 1)
        : null;
      this.params.currPage = 1;
      if (star != null) {
        //时间判断
        if (end != null) {
          if (end >= star) {
            if (this.type == "industrial") {
              this.getIndustryDataDetail(this.params);
            } else {
              this.getHaiGuanDataDetail(this.params);
            }
          } else {
            this.$message.error("时间选择错误!");
          }
        }
      } else {
        if (this.type == "industrial") {
          this.getIndustryDataDetail(this.params);
        } else {
          this.getHaiGuanDataDetail(this.params);
        }
      }

      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    // 分页
    handleCurrentChange(val) {
      this.params.currPage = val;
      if (this.type == "industrial") {
        this.getIndustryDataDetail(this.params);
      } else {
        this.getHaiGuanDataDetail(this.params);
      }
    },
    // 公司高亮
    cellStyle1({ row, column, rowIndex, columnIndex }) {
      if (column.label == "企业名称" || column.label == "法人单位名称") {
        return `color:#3583ED;font-weight:bold;cursor: pointer;`;
      } else {
        return "";
      }
    },
    // 去搜索页
    getDetails1(row, column) {
      var params = {
        entId: row.entid
      };
      if (row.company_name == "***" || row.frdwmc == "***") {
        return;
      } else {
        if (column.property == "company_name" || column.property == "frdwmc") {
          if (row.entid && row.entid != "") {
            api.checkExistBussiness(params).then(res => {
              if (res) {
                this.$router.push({
                  path: "/enterprisesDetail",
                  query: params
                });
              }
            });
          } else {
            this.$message.error("暂无数据!");
          }
        }
      }

      // if (column.property == "department") {
      //   let companyName = row.department;
      //   let creditCode = row.uniqueCode;
      //   let dbcode = this.$route.query.dbcode;
      //   this.$router.push({
      //     path: `/medicine/${dbcode}`,
      //     query: {
      //       creditCode
      //     }
      //   });
      //   sessionStorage.setItem("companyName", JSON.stringify(companyName));
      // }
    },
    // 下载
    enter() {
      this.hint = true;
    },
    leave() {
      this.hint = false;
    },
    down() {
      var that = this;
      var num = this.type == "industrial" ? "4" : "3";
      magic.loginOrRights(num).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
        } else {
          api.weighterRights(num).then(res => {
            if (res.data) {
              if (num == 3) {
                that.downloadTableHg();
              } else {
                that.downloadTable();
              }
            } else {
              that.$message.error("请您购买！");
            }
          });
        }
      });
    },
    downloadTable() {
      axios({
        method: "get",
        url: window.normalUrl + "/IndustrialVisualViewController/outPutExcel", // 请求地址
        responseType: "arraybuffer",
        observe: "response"
      }).then(res => {
        const fileName =
          this.type == "industrial" ? "工业列表.xls" : "海关列表.xls";
        let blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    downloadTableHg() {
      axios({
        method: "get",
        url: window.normalUrl + "/HaiGuanVisualViewController/outPutExcel", // 请求地址
        responseType: "arraybuffer",
        observe: "response"
      }).then(res => {
        const fileName =
          this.type == "industrial" ? "工业列表.xls" : "海关列表.xls";
        let blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },

    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    processingData(data) {
      data.forEach((v, i) => {
        if (v.sonList != null && v.sonList.length > 0) {
          this.processingData(v.sonList);
        } else {
          v.sonList = null;
        }
      });
    },
    getIndustrialDimensions() {
      api.getIndustrialDimensions().then(res => {
        this.regionData = res.data.region; //企业所在地
        this.companyTypeData = res.data.companyType; //企业登记注册类型
        this.holdingTypeData = res.data.kgType; //企业控股情况
        // this.entNameData = res.data.entName; //企业名称
        this.relationData = res.data.relationType; //企业隶属关系

        this.selectedParaData = res.data.selectedParameters; //选择展示字段以英文，都好隔开的字符串
        this.timeData = res.data.time; //时间
        // console.log(this.selectedParaData, " 企业选择字段");
        this.processingData(this.regionData);
        this.processingData(this.companyTypeData);
        this.processingData(this.holdingTypeData);
        this.processingData(this.relationData);
      });
    },
    getHaiGuanDimensions() {
      api.getHaiGuanDimensions().then(res => {
        this.companyTypeData = res.data.companyType; //企业性质
        this.trademodeData = res.data.trademode; //贸易方式
        this.tradeflowData = res.data.tradeflow; //贸易流向
        this.transportData = res.data.transport; //运输方式
        this.regionData = res.data.region; //企业所在地
        this.timeData = res.data.time; //时间
        this.hsnameData = res.data.hsname; //HS名称
        this.selectedParametersData = res.data.selectedParameters; //选择字段
        this.processingData(this.companyTypeData);
        this.processingData(this.trademodeData);
        this.processingData(this.tradeflowData);
        this.processingData(this.transportData);
        this.processingData(this.regionData);
        // console.log(this.hsnameData, " hs名称");
        // console.log(this.selectedParametersData, " 海关选择字段");
      });
    },
    getIndustryDataDetail(params) {
      if (this.gyregion) {
        var arr = [];
        this.gyregion.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.region = arr.toString(); //企业所在地
        });
        if (arr.length < 1) {
          params.region = null;
        }
      }
      if (this.gycompanyType) {
        var arr = [];
        this.gycompanyType.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.companyType = arr.toString(); //企业性质
        });
        if (arr.length < 1) {
          params.companyType = null;
        }
      }
      if (this.gyrelationType) {
        var arr = [];
        this.gyrelationType.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.relation = arr.toString(); //企业隶属关系
        });
        if (arr.length < 1) {
          params.relation = null;
        }
      }
      if (this.gyholdingType) {
        var arr = [];
        this.gyholdingType.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.holdingType = arr.toString(); //企业控股情况
        });
        if (arr.length < 1) {
          params.holdingType = null;
        }
      }
      params.startYear = this.startYear.slice(0, this.startYear.length - 1)
        ? this.startYear.slice(0, this.startYear.length - 1)
        : null; //开始时间
      params.endYear = this.endYear.slice(0, this.endYear.length - 1)
        ? this.endYear.slice(0, this.endYear.length - 1)
        : null; //结束时间
      if (!params.selectedPara) {
        delete params.selectedPara;
      }
      api.getIndustryDataDetail(params).then(res => {
        this.majorList = res.data.data;
        this.parameters = res.data.parameters;
        this.total = res.data.total;
      });
    },
    getHaiGuanDataDetail(params) {
      if (this.hgregion) {
        var arr = [];
        this.hgregion.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.region = arr.toString(); //企业所在地
        });
        if (arr.length < 1) {
          params.region = null;
        }
      }

      if (this.hgtransport) {
        var arr = [];
        this.hgtransport.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.transport = arr.toString(); //运输方式
        });
        if (arr.length < 1) {
          params.transport = null;
        }
      }
      if (this.hgtradeflow) {
        var arr = [];
        this.hgtradeflow.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.tradeflow = arr.toString(); //贸易流向
        });
        if (arr.length < 1) {
          params.tradeflow = null;
        }
      }
      if (this.hgtrademode) {
        var arr = [];
        this.hgtrademode.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.trademode = arr.toString(); //贸易方式
        });
        if (arr.length < 1) {
          params.trademode = null;
        }
      }
      if (this.hgcompanyType) {
        var arr = [];
        this.hgcompanyType.forEach((v, i) => {
          arr.push(v[v.length - 1]);
          params.companyType = arr.toString(); //企业性质
        });
        if (arr.length < 1) {
          params.companyType = null;
        }
      }
      params.startYear = this.startYear.slice(0, this.startYear.length - 1)
        ? this.startYear.slice(0, this.startYear.length - 1)
        : null; //开始时间
      params.endYear = this.endYear.slice(0, this.endYear.length - 1)
        ? this.endYear.slice(0, this.endYear.length - 1)
        : null; //结束时间
      if (!params.hsname) {
        delete params.hsname;
      }
      if (!params.selectedPara) {
        delete params.selectedPara;
      }
      api.getHaiGuanDataDetail(params).then(res => {
        this.majorList = res.data.data;
        this.parameters = res.data.parameters;
        this.total = res.data.total;
      });
    },
    //选择字段--每一个成员被选中后，全选按钮自动改变
    handleCheckedCitiesChange2(value) {
      let checkedCount = value.length;
      this.searchText.checkAll = checkedCount === this.selectedParaData.length;
      this.searchText.isIndeterminate =
        checkedCount > 0 && checkedCount < this.selectedParaData.length;
    },
    //hg选择字段--每一个成员被选中后，全选按钮自动改变
    hghandleCheckedCitiesChange2(value) {
      let checkedCount = value.length;
      this.searchText.checkAll =
        checkedCount === this.selectedParametersData.length;
      this.searchText.isIndeterminate =
        checkedCount > 0 && checkedCount < this.selectedParametersData.length;
    },
    //选择字段--弹出按钮事件
    chooseTextFn(productId) {
      //判断是否有权限，是否登录
      window.that = this;
      magic.loginOrRights(productId).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          that.$message.error("请您购买！");
          return;
        }
        let bools = $(".box-card_two").css("display");
        bools == "none"
          ? $(".box-card_two").css("display", "block")
          : $(".box-card_two").css("display", "none");
        $(".box-hsNameFn").css("display", "none");
      });
    },
    // 选中hsName
    checkHsName(data, val) {
      this.hsNameText.checkedCities = val.checkedNodes;
      this.hsNameText.choosedItems = val.checkedKeys;
    },
    // 工业选中字段
    checkHgName(data, val) {
      this.searchText.checkedCities = val.checkedNodes;
      this.searchText.choosedItems = val.checkedKeys;
    },
    //hs字段--弹出按钮事件
    hsNameFn(productId) {
      //判断是否有权限，是否登录
      window.that = this;
      magic.loginOrRights(productId).then(res => {
        if (!res) {
          that.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          that.$message.error("请您购买！");
          return;
        }
        let bools = $(".box-hsNameFn").css("display");
        bools == "none"
          ? $(".box-hsNameFn").css("display", "block")
          : $(".box-hsNameFn").css("display", "none");
        $(".box-card_two").css("display", "none");
      });
    },
    //hs删除所有已选字段
    hsRemoveFn() {
      this.hsNameText.checkedCities = [];
      this.hsNameText.choosedItems = [];
      this.$refs.tree.setCheckedKeys([]);
      this.hsNameText.checkAll = false;
    },
    //工业删除所有已选字段
    hgRemoveFn() {
      this.searchText.checkedCities = [];
      this.searchText.choosedItems = [];
      this.$refs.trees.setCheckedKeys([]);
      this.searchText.checkAll = false;
    },
    // hs删除某一个元素
    hsRemoveFn2(item) {
      let data = this.hsNameText.checkedCities;
      Array.prototype.remove = function(val) {
        //删除数组里某一个元素
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      setTimeout(() => {
        this.hsNameText.checkedCities.remove(item);
        this.hsNameText.choosedItems.remove(item.typeId);
        this.$refs.tree.setCheckedNodes(this.hsNameText.checkedCities);
      }, 300);
    },
    // hs删除某一个元素
    hgRemoveFn2(item) {
      let data = this.hsNameText.checkedCities;
      Array.prototype.remove = function(val) {
        //删除数组里某一个元素
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      setTimeout(() => {
        this.searchText.checkedCities.remove(item);
        this.searchText.choosedItems.remove(item.typeId);
        this.$refs.trees.setCheckedNodes(this.searchText.checkedCities);
      }, 300);
    },
    //hs商品确定按钮
    hsNameBtn() {
      var str = "";
      $(".box-hsNameFn").css("display", "none");
      this.hsNameText.checkedCities.forEach((v, i) => {
        str += v.typeName + ",";
      });

      this.hsname = str.substr(0, str.length - 1);
      this.params.hsname = this.hsNameText.choosedItems.toString();
    },
    //海关选择字段字段--确定按钮
    hgNameBtn() {
      var str = "";
      $(".box-card_two").css("display", "none");
      this.searchText.checkedCities.forEach((v, i) => {
        str += v.typeName + ",";
      });

      this.gyselectedPara = str.substr(0, str.length - 1);
      this.params.selectedPara = this.searchText.choosedItems.toString();
    },
    //选择字段--确定按钮
    searchTextBtn() {
      $(".box-card_two").css("display", "none");
      let str = "";
      let data = this.searchText.checkedCities;
      data.forEach((v, i) => {
        this.selectedParametersData.forEach((s, k) => {
          if (v == s.name) {
            str += s.value + ",";
          }
        });
      });
      this.hgselectedPara = data.toString();
      this.params.selectedPara = str.substr(0, str.length - 1);
    },
    //gy选择字段--全选
    handleCheckAllChange2(val) {
      let _this = this;
      if (val) {
        this.searchText.checkedCities = [];
        let select = this.selectedParaData;
        for (let i = 0; i < select.length; i++) {
          _this.searchText.checkedCities.push(select[i].typeName);
        }
      } else {
        this.searchText.checkedCities = [];
      }
      this.searchText.isIndeterminate = false;
    },
    //hg选择字段--全选
    hghandleCheckAllChange2(val) {
      let _this = this;
      if (val) {
        this.searchText.checkedCities = [];
        let select = this.selectedParametersData;
        for (let i = 0; i < select.length; i++) {
          _this.searchText.checkedCities.push(select[i].name);
        }
      } else {
        this.searchText.checkedCities = [];
      }
      this.searchText.isIndeterminate = false;
    },
    //删除所有已选字段
    removeClickedUpMarketFn2() {
      this.searchText.checkedCities = [];
      this.searchText.checkAll = false;
    },
    //删除单个已选字段
    removeOneSelectedUpMarketFn2(item) {
      let data = this.searchText.checkedCities;
      Array.prototype.remove = function(val) {
        //删除数组里某一个元素
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      setTimeout(() => {
        this.searchText.checkedCities.remove(item);
      }, 300);
    }
  },
  mounted() {
    if (this.type == "industrial") {
      this.getIndustrialDimensions();
      this.getIndustryDataDetail(this.params);
    } else if (this.type == "customs") {
      this.getHaiGuanDimensions();
      this.getHaiGuanDataDetail(this.params);
    }
  }
};
</script>

<style scoped lang="less">
.selectBox {
  p {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dfecf7;
  }
}
.w93 {
  width: 121px;
  text-align: left;
}
/deep/ .el-table__header-wrapper {
  background: #052b4f;
}

/deep/ .el-cascader {
  width: 332px;
}
@import "../assets/less/style.less";
@import "../assets/less/right.less";
@import "../assets/less/moreThanThree.less";
.rightBottom {
  background: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dataList.vue